import { Injectable } from '@angular/core';
import { EpErpRestService, EpDialogService } from '@epicor/ux-platform';
import { Observable, of, throwError } from 'rxjs';
import { take, catchError, mergeMap } from 'rxjs/operators';
import { IContextData } from '@epicor/appcommunicator';
import { ContextService } from './context.service';

@Injectable({
  providedIn: 'root'
})
export abstract class ErpService {
  protected abstract readonly serviceName: string;

  constructor(protected epErpRestService: EpErpRestService, protected contextService: ContextService) {}

  protected contextData(): Observable<IContextData> {
    return this.contextService.contextData().pipe(take(1));
  }

  /**
   * Post to the ERP Rest Service
   * @param path Path, i.e. GetList, etc
   * @param data Data for params
   */
  protected post(path: string, data: object): Observable<any> {
    if (!this.contextService.validateLoggedIn()) {
      return of({});
    }
    return this.contextService.contextData().pipe(
      take(1),
      mergeMap(_contextData => {
        return this.epErpRestService.post(this.serviceName, path, data);
      }),
      catchError(error => {
        ErpService.handleError(error);
        throw error;
      })
    );
  }

  /**
   * Get to the ERP Rest Service
   * @param path Path, i.e. GetList, etc
   * @param params Data for params
   */

  protected get(path: string, params: object): Observable<any> {
    if (!this.contextService.validateLoggedIn()) {
      return of({});
    }
    return this.contextService.contextData().pipe(
      take(1),
      mergeMap(_contextData => {
        return this.epErpRestService.get(this.serviceName, path, params);
      }),
      catchError(error => {
        ErpService.handleError(error);
        return throwError(() =>error);
      })
    );
  }

  protected static handleError(error: any) {
    let errorMessage: string;
    if (error.response) {
      if (error.response.error.ErrorMessage) {
        errorMessage = error.response.error.ErrorMessage;
      } else if (error.response.error) {
        errorMessage = error.response.error;
      } else {
        errorMessage = error.response.message;
      }
      EpDialogService.error(errorMessage);
    } else {
      EpDialogService.error(error);
    }
  }
}
